import React from "react";
import { LoginCallback } from "@okta/okta-react";
import Loader from "../utils/Loader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "../App.css";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import AdminstrationLayout from "../pages/AdminstrationLayout";
import Container from "../layout/Container";
import PrivateRoute from "../hoc/PrivateRoute";
import {
  createTheme,
  ThemeProvider as MaterialThemeProvider,
} from "@mui/material";
import InternalUpload from "../components/Upload/InternalUpload";
import ExternalUpload from "../components/Upload/ExternalUpload";
import PotatoProtectionLayout from "../pages/PotatoProtectionLayout";
import VarietyDetail from "../components/PotatoProtection/LargeScreen/VarietyDetails/VarietySection/VarietyDetail";

import Favorites from "../pages/Favorites";
import Library from "../pages/Library";

import SubjectMatterExperts from "../pages/SubjectMatterExperts";
import LinkScreen from "../components/LinkScreen/LinkScreen";
import Document from "../components/DocumentScreen/Document";
import LibraryDetails from "../pages/LibraryDetails";

import AppDynamics from "../AppDynamics";
import RepalceCards from "../components/Administration/Screens/Spotlight/RepalceItems/RepalceCards";
import SearchPage from "../pages/SearchPage";
import FritoForumMainPage from "../components/FritoForumPage/FritoForumMainPage";
import FritoForumDetailPage from "../components/FritoForumPage/FritoForumDetailPage";
import Curator from "../components/Curator/Curator";
import DeniedArtifactHistoryDetails from "../components/Curator/DeniedHistory/DeniedArtifactHistoryDetails";
import UploadLayout from "../components/Upload-History-Approval/UploadLayout";
import Login from "../pages/Login";

import VideoDetails from "../components/VideoScreen/VideoDetails";
import SpecialProjectEditScreen from "../components/Administration/Screens/SpecialProject/SpecialProjectEditScreen";
import RequestInformationDetails from "../components/RFI/RfiDetails/RequestInformationDetails";

import ArtificatPage from "../components/Curator/ArtifactHistory/ArtificatPage";
import AddRequestInformation from "../components/RFI/AddRFI/AddRequestInformation";
import RequestForInformation from "../pages/RequestForInformation";
import { useSelector } from "react-redux";
import UserBasedRoute from "../hoc/UserBasedRoute";
import NotFound from "../pages/NotFound";
import SpeacialProject from "../pages/SpeacialProject";
import { ThemeProvider } from "pepsico-ds";
import { CURATOR_PAGE_API_CONSTANT } from "../constant/constant";
import AddSpotlight from "../components/Administration/Screens/Spotlight/AddSpotlight/AddSpotlight";
import CreateForumLayout from "../components/Administration/Screens/ForumBuilder/createForum/CreateForumLayout";
import DynamicPage from "../components/DynamicPage/DynamicPage";
import CreatePageBuilderLayout from "../components/Administration/Screens/PageBuilder/createpages/CreatePageBuilderLayout";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient();
const theme = createTheme();
const AppRoutes = () => {
  const { flagUser } = useSelector((store) => store.user);
  const { internalRoutes } = useSelector((store) => store.nav);

  return (
    <QueryClientProvider client={queryClient}>
      <MaterialThemeProvider theme={theme}>
        <ThemeProvider>
          {/* <AppDynamics /> */}
          <Routes>
            <Route
              path="/login/callback"
              element={<LoginCallback loadingElement={<Loader />} />}
            />
            <Route path="/login" element={<Login />} />

            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Container />}>
                <Route path="" element={<Home />} />
                <Route path="/document/:contentId" element={<Document />} />
                <Route
                  path="/add-request-information"
                  element={<AddRequestInformation />}
                />
                {internalRoutes?.map((route) => (
                  <Route
                    key={route?.slug}
                    path={route?.url}
                    element={
                      <DynamicPage
                        slug={route?.slug}
                        header={route?.label}
                        pageId={route?.pageId}
                      />
                    }
                  />
                ))}

                <Route
                  path="/details-request-information/:id"
                  element={<RequestInformationDetails />}
                />
                <Route path="/search-results" element={<SearchPage />} />
                <Route
                  path="/library-details/:id"
                  element={<LibraryDetails />}
                />
                <Route
                  path="/video-details/:contentId"
                  element={<VideoDetails />}
                />
                <Route path="/favorites" element={<Favorites />} />
                <Route
                  path="/frito-forum-detail-page/:id"
                  element={<FritoForumDetailPage />}
                />
                <Route path="/link/:contentId" element={<LinkScreen />} />

                <Route element={<UserBasedRoute />}>
                  <Route path="/admin" element={<AdminstrationLayout />} />
                  {flagUser?.roleName?.toLowerCase() === "external" ? (
                    <Route path="/upload" element={<ExternalUpload />} />
                  ) : (
                    <Route path="/upload" element={<InternalUpload />} />
                  )}
                  <Route
                    path="special-projects"
                    element={<SpeacialProject />}
                  />
                  <Route path="/admin/forum" element={<CreateForumLayout />} />
                  <Route
                    path="/admin/pageBuilder"
                    element={<CreatePageBuilderLayout />}
                  />
                  <Route
                    path="/admin/pageBuilder/:id"
                    element={<CreatePageBuilderLayout />}
                  />
                  <Route
                    path="/admin/forum/:id"
                    element={<CreateForumLayout />}
                  />
                  <Route
                    path="/potato-protection-status"
                    element={<PotatoProtectionLayout />}
                  />
                  <Route
                    path="/potato-protection-status/:id"
                    element={<VarietyDetail />}
                  />

                  <Route path="/library" element={<Library />} />

                  <Route
                    path="/subject-matter-experts"
                    element={<SubjectMatterExperts />}
                  />

                  <Route
                    path="/admin/replace/:replaceId"
                    element={<RepalceCards />}
                  />
                  <Route path="/admin/add" element={<AddSpotlight />} />
                  <Route
                    path="/frito-forum-main-page"
                    element={<FritoForumMainPage />}
                  />

                  <Route path="/curator" element={<Curator />} />
                  <Route
                    path="/curator/pending-approval/:id"
                    element={
                      <ArtificatPage
                        key={CURATOR_PAGE_API_CONSTANT.pending_approval}
                        pageName={CURATOR_PAGE_API_CONSTANT.pending_approval}
                      />
                    }
                  />
                  <Route
                    path="/curator/yearly-review/:id"
                    element={
                      <ArtificatPage
                        key={CURATOR_PAGE_API_CONSTANT.yearly_review}
                        pageName={CURATOR_PAGE_API_CONSTANT.yearly_review}
                      />
                    }
                  />
                  <Route
                    path="/curator/artifact-history/:id"
                    element={
                      <ArtificatPage
                        key={CURATOR_PAGE_API_CONSTANT.artificat_history}
                        pageName={CURATOR_PAGE_API_CONSTANT.artificat_history}
                      />
                    }
                  />
                  <Route
                    path="/curator/denied-artificats-history/:id"
                    element={<DeniedArtifactHistoryDetails />}
                  />
                  <Route
                    path="/pending-approvals-history"
                    element={<UploadLayout />}
                  />
                  <Route path="/history" element={<UploadLayout />} />

                  <Route
                    path="/request-information"
                    element={<RequestForInformation />}
                  />

                  <Route
                    path="/special-project-edit"
                    element={<SpecialProjectEditScreen />}
                  />

                  <Route
                    path="/request-information"
                    element={<RequestForInformation />}
                  />
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ThemeProvider>
      </MaterialThemeProvider>
    </QueryClientProvider>
  );
};

export default AppRoutes;
